import PropTypes from 'prop-types';
import ParticipantIconsInlineImpl from './participant-icons-inline.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * @class ParticipantIconsInline
 * @memberof Mojito.Presentation.Components
 */

/**
 * ParticipantIconsInline prop types.
 *
 * @property {Array} [participants = []] - Event participants (at least 2 items).
 * @property {string} sportId - Sport identifier for CompetitorIcon.
 * @property {boolean} [homeAway] - Home/away layout used to order the participants.
 * @property {string} separator - Separator character to display between icons.
 *
 * @memberof Mojito.Presentation.Components.ParticipantIconsInline
 */
const propTypes = {
    participants: PropTypes.array,
    sportId: PropTypes.string,
    homeAway: PropTypes.bool,
    separator: PropTypes.string,
};

const defaultProps = {
    participants: [],
};

export default UIView(
    'ParticipantIconsInline',
    ParticipantIconsInlineImpl,
    propTypes,
    defaultProps
);
